import React from "react";
import TimeAgo from "react-timeago";
import { cleanDate } from "../../../../util/app";

const LeaveList = ({ items = [], onEdit, onView }) => {
    if (items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No leave has been added for this patient yet</strong>
            </div>
        );
    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th style={{ width: "5%" }} className="text-center">
                        SN
                    </th>
                    <th style={{ width: "20%" }}>Leave</th>
                    <th style={{ width: "15%" }}>Date Out</th>
                    <th style={{ width: "15%" }}>Clothing Description</th>
                    <th style={{ width: "15%" }}>Venue</th>
                    <th style={{ width: "15%" }}>Date Back</th>
                    <th style={{ width: "15%" }} className="text-center">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                {items.map((item, idx) => (
                    <tr>
                        <td className="text-center">
                            <strong>{idx + 1}</strong>
                        </td>
                        <td>
                            <strong>{item.type.name}</strong>
                            <br />
                            {!item.authorized && <span className="badge badge-pill badge-danger fade-in">Unauthorized Leave</span>}
                            {item.authorized && <span className="badge badge-pill badge-success fade-in">Authorized Leave</span>}

                            <br />
                            <strong>Status: </strong>
                            {item.status}
                            <br />
                            <small>
                                <TimeAgo date={new Date(item.created_at)}></TimeAgo>
                            </small>
                        </td>
                        <td>{cleanDate(item.datetime_out)}</td>
                        <td>
                            {item.clothing_desc}
                            <br />
                            {item.photo_updated && <span className="badge badge-pill badge-dark fade-in">Photo Updated</span>}
                        </td>
                        <td>{item.venue}</td>
                        <td>{cleanDate(item.return_datetime)}</td>
                        <td className="text-center">
                            <button onClick={() => onEdit(item)} title="Update" className="mdl-button fade-in mdl-button--icon mdl-button--colored btn-default margin-right-10">
                                <i className="material-icons text-success">edit</i>
                            </button>
                            <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                <i className="material-icons text-primary">arrow_right_alt</i>
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default LeaveList;
